import { Grid } from '@mui/material';
import { Button } from 'gf-ui-components-mui-lib';
import { Leftarr, Rightarr } from '@/icons';
import tickSvg from '@/images/svg/tick.svg'


export const PopupPaginationBtn = ({ onClick, children, startIcon, handleLeft, handleRight, setup = false, handleTick, dataId = '' }: any) => {
  return (
    <Grid
      style={{
        display: 'flex',
        paddingRight: '0px',
        justifyContent: 'space-between',
        alignSelf: 'stretch',
        marginBottom: '0',
        paddingBottom: '0'
      }}
      data-testid={dataId}
    >
      <Grid style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
        <Button
          variant="contained"
          sx={{
            display: 'flex',
            width: '52px !important',
            height: '52px',
            minWidth: '0px',
            padding: '12px',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '4px',
            borderRadius: '9px',
            border: '1px solid var(--stroke, #E2E8F0)',
            background: '#FFF',
            boxShadow: '2px 4px 10px 0px rgba(180, 191, 205, 0.20)',
            color: 'black',
            ':hover': {
              gap: '4px',
              borderRadius: '9px',
              border: '1px solid var(--stroke, #E2E8F0)',
              background: '#FFF',
              boxShadow: '0px 2px 12px 0px rgba(0, 0, 0, 0.15)'
            }
          }}
          onClick={handleLeft}
          className='left-btn'
        >
          <Leftarr />
        </Button>
        <Button
          variant="contained"
          sx={{
            display: 'flex',
            width: '52px !important',
            minWidth: '0px',
            height: '52px',
            padding: '12px',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '4px',
            borderRadius: '9px',
            border: '1px solid var(--stroke, #E2E8F0)',
            background: '#FFF',
            color: 'black',
            boxShadow: '2px 4px 10px 0px rgba(180, 191, 205, 0.20)',
            ':hover': {
              gap: '4px',
              borderRadius: '9px',
              border: '1px solid var(--stroke, #E2E8F0)',
              background: '#FFF',
              boxShadow: '0px 2px 12px 0px rgba(0, 0, 0, 0.15)'
            }
          }}
          onClick={handleRight}
          className='right-btn'
        >
          <Rightarr />
        </Button>
      </Grid>
      <Button
        sx={{
          display: 'flex',
          width: '71px',
          minWidth: '0px',
          height: '52px',
          padding: '16px',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '4px',
          color: 'white',
          marginRight: '8px',
          background: 'var(--btn-01-primary-enabled, #2469F3)',
          ':hover': {
            borderRadius: '4px',
            color: 'white',
            background: 'var(--btn-01-primary-enabled, #2469F3)',
            boxShadow: '0px 2px 12px 0px rgba(0, 0, 0, 0.15)'
          }
        }}
        onClick={handleTick}
        children={<img src={tickSvg} alt="Example Image" style={{ marginLeft: '5px' }} width={24} height={24} />}
        variant="contained"
        className='tick-btn'
      />
    </Grid>
  );
};

export default PopupPaginationBtn;
